export default __webpack_public_path__ + "static/media/glitch06.cdf2f8d2.png";